// css =>
import "../../BaseStructure.css";
import Styled from "./category-filter-menu.module.css";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';

// context =>
import { useTheme } from '../../context/theme-context';

const CategoryFilterMenu = (props) => {
    const { language } = useLanguage();
    const { theme, toggleTheme } = useTheme();
    const t = (key) => getTranslation(language, key);

    return (
        <div
            className={`row ${ Styled.category_and_filter_box_section } `}>
            <div
                className={`row ${ Styled.category_and_filter_box } `}
                style={{
                    backgroundColor: theme === "day" ? "#C9CCC2" : ""
                }}>
                <div
                    className={`col-6 ${ Styled.category_box } `}
                    onClick={ props.onClick }
                    style={{
                        borderColor: theme === "day" ? "#474D3D" : "",
                        float: language === "fa" ? "left" : ""
                    }}>
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : ""
                        }}>{ props.subMenuTitle }</p>
                    <div
                        style={{
                            backgroundColor: theme === "day" ? "#474D3D" : ""
                        }}></div>
                </div>

                <div className={`col-6 ${ Styled.desktop_info_text } `}>
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : ""
                        }}
                    >{ props.mainTitle }</p>
                </div>

                <div className="col-6">
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : ""
                        }}>{ props.numberOfItems }</p>
                </div>
            </div>
        </div>
    );
}

export default CategoryFilterMenu;
